import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './AdminLoginFormControls.styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { injectIntl, defineMessages } from 'react-intl';
import 'react-simple-keyboard/build/css/index.css';
import Keyboard from 'react-simple-keyboard';
const cSpinner = require('../../../assets/images/cspinner.gif');

const messages = defineMessages({
  Email: {
    id: 'Admin.Login.Email',
    defaultMessage: 'Email'
  },
  Password: {
    id: 'Admin.Login.Password',
    defaultMessage: 'Password'
  },
  SignIn: {
    id: 'Admin.Login.SignIn',
    defaultMessage: 'Sign In'
  },
  ForgetPassword: {
    id: 'Admin.Login.ForgotPassword',
    defaultMessage: 'Forgot Password'
  },
  Back: {
    id: 'Welcome.Back',
    defaultMessage: 'Back'
  },
  SecureBadgeLogin: {
    id: 'Admin.Login.SecureBadgeLogin',
    defaultMessage: 'Secure Badge Login'
  }
});

export class AdminLoginFormControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maxlength: 100,
      SelectedInput: 'username',
      layoutName: 'default',
      username: '',
      password: ''
    };
  }
  static propTypes = {
    test: PropTypes.string,
    error: PropTypes.object
  };
  onChange = (input) => {
    if (this.state.SelectedInput) {
      document.querySelector('#' + this.state.SelectedInput).value = input;
      var event = new Event('change', { bubbles: true });
      event.simulated = true;
      document
        .querySelector('#' + this.state.SelectedInput)
        .dispatchEvent(event);
      this.change(this.state.SelectedInput, event);
    }
  };
  onKeyPress = (button) => {
    if (['{capslock}', '{shiftleft}', '{shiftright}'].includes(button))
      this.handleShiftButton();
  };
  handleShiftButton = () => {
    const {
      state: { layoutName }
    } = this;
    const shiftToggle = layoutName === 'default' ? 'shift' : 'default';
    this.setState({ layoutName: shiftToggle });
  };
  change = (name, e) => {
    let input = e.target.value;
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.keyboard.setInput(input);
    });
    this.props.handleChange(e);
    this.props.setFieldTouched(name, true, false);
  };
  Focus = (obj) => {
    let ref = obj.target.name;
    if (this.keyboard) {
      this.setState({ SelectedInput: ref });
      this.setState({ maxlength: 100 });
      this.keyboard.setInput(document.querySelector('#' + ref).value);
    }
  };

  forgotPassword = (e) => {
    this.props.onForgotPasswordRequest(this.props.values);
    e.preventDefault();
  };

  contactSupport = (e) => {
    this.props.onContactSupportRequest(this.props.values);
    e.preventDefault();
  };

  sendData = () => {
    this.props.handleusername && this.props.handleusername(this.state.username);
  };

  render() {
    const { classes, intl } = this.props;
    const {
      handleSubmit,
      handleforgotPassword,
      handleBack,
      isValid,
      isProcessing
    } = this.props;
    this.sendData();

    return (
      <div>
        <form onSubmit={handleSubmit} className={classNames(classes.container)}>
          <TextField
            id="username"
            name="username"
            InputProps={{
              classes: {
                input: classes.textField
              }
            }}
            label={intl.formatMessage(messages.Email)}
            autoComplete="off"
            autoCapitalize="false"
            autoFocus
            fullWidth
            onChange={this.change.bind(null, 'username')}
            onFocus={this.Focus.bind('username')}
            value={this.state.username}
          />
          <TextField
            id="password"
            name="password"
            InputProps={{
              classes: {
                input: classes.textField
              }
            }}
            label={intl.formatMessage(messages.Password)}
            type={'password'}
            autoComplete="off"
            autoCapitalize="false"
            onChange={this.change.bind(null, 'password')}
            onFocus={this.Focus.bind('password')}
            value={this.state.password}
          />
          <div style={{ textAlign: 'center' }}>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={
                !isValid || isProcessing
                  ? classNames(classes.disabledPrimaryButton)
                  : classNames(classes.primaryButton)
              }
              disabled={!isValid || isProcessing}
            >
              {isProcessing ? (
                <img
                  src={cSpinner}
                  style={{ width: '30px' }}
                  alt="In Process"
                />
              ) : (
                intl.formatMessage(messages.SignIn)
              )}
            </Button>
          </div>

          <div className={classNames(classes.buttonContainer)}>
            <Button
              type="button"
              color="primary"
              className={classNames(classes.backButton)}
              onClick={handleBack}
            >
              {intl.formatMessage(messages.Back)}
            </Button>
            <Button
              type="button"
              color="primary"
              variant="contained"
              className={classNames(classes.backButton)}
              onClick={handleforgotPassword}
            >
              {intl.formatMessage(messages.ForgetPassword)}
            </Button>
          </div>
          <div className={classNames(classes.linkContainer)}></div>
        </form>
        <div className={classNames(classes.simpleKeyboard)}>
          <Keyboard
            keyboardRef={(r) => (this.keyboard = r)}
            layoutName={this.state.layoutName}
            maxLength={{ default: this.state.maxlength }}
            layout={{
              default: [
                '` 1 2 3 4 5 6 7 8 9 0 - = {backspace}',
                'q w e r t y u i o p [ ] \\',
                "{capslock} a s d f g h j k l ; '",
                'z x c v b n m , . /',
                '.com @ {space}'
              ],
              shift: [
                '~ ! @ # $ % ^ & * ( ) _ + {backspace}',
                'Q W E R T Y U I O P { } |',
                '{capslock} A S D F G H J K L : "',
                'Z X C V B N M < > ?',
                '.com @ {space}'
              ]
            }}
            onChange={(input) => this.onChange(input)}
            onKeyPress={(button) => this.onKeyPress(button)}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  injectIntl(AdminLoginFormControls)
);
